// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"8e75b21f","488":"305cece2","538":"2d4ef790","580":"1268724d"}[chunkId] + ".chunk.js";
};